import React, { useMemo } from 'react'
import { useLearningSpace } from 'contexts/LearningSpaceContext'
import { useTheme } from '@material-ui/core'
import { ChartDataSets } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { ClassEventParticipationRate } from 'types'

interface Props {
  statistics: ClassEventParticipationRate[]
  selectedClasses: { selected: boolean; className: string; id: string }[]
}

const EventParticipationRateBarChart: React.FC<Props> = (props) => {
  const learningSpace = useLearningSpace()
  const { selectedClasses, statistics } = props
  const theme = useTheme()

  const averages = useMemo(() => {
    let result: { [classId: string]: { average: number } } = {}
    selectedClasses.forEach((classInfo) => {
      const classStatistics = statistics.filter(
        (statistic) =>
          statistic.classId === classInfo.id &&
          statistic.learningSpaceId === learningSpace.id
      )

      let totalParticipated = 0
      let totalStudents = 0
      classStatistics.forEach((statistic) => {
        totalParticipated += statistic.totalParticipations
        totalStudents += statistic.maximumParticipations
      })

      const average = totalParticipated / totalStudents

      result[classInfo.id] = { average: Math.round(average * 100) }
    })
    return result
  }, [learningSpace.id, selectedClasses, statistics])

  const labels = useMemo(
    () => selectedClasses.map((classInfo) => classInfo.className),
    [selectedClasses]
  )

  const datasets = useMemo(() => {
    const datasets: ChartDataSets[] = [
      {
        label: 'Tỉ lệ tham gia sự kiện trung bình (%)',
        data: selectedClasses.map((classInfo) =>
          averages[classInfo.id]?.average ? averages[classInfo.id].average : 0
        ),
        backgroundColor: theme.palette.primary.main
      }
    ]

    return datasets
  }, [averages, selectedClasses, theme.palette.primary.main])

  return (
    <>
      <Bar
        height={80}
        data={{ labels: labels, datasets: datasets }}
        options={{
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                barPercentage: 0.2
              } as any
            ]
          },
          title: {
            text: 'Tổng quan tỉ lệ tham gia sự kiện',
            display: true
          }
        }}
      />
    </>
  )
}

export default EventParticipationRateBarChart
